export function saveToLocalStorage(key: string, value: any) {
  window.localStorage.setItem(key, JSON.stringify(value));
}

export function getFromLocalStorage(key: string): any | null {
  try {
    const object = window.localStorage.getItem(key);
    if (object != null) 
      return JSON.parse(object);
    
  } catch (error) {}
  
  return null;
}
